/** Human-readable labels for system role keys (backend `roles.key`). */
export const ROLE_LABELS: Record<string, string> = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Branch Admin",
  SALES_POINT_ADMIN: "Sales Point Admin",
  DEPARTMENT_ADMIN: "Sales Point Admin",
  OPERATOR: "Operator",
  MERCHANT: "Merchant",
  GROCERY_STORE: "Grocery Store",
};

export function formatRoleLabel(role: string, catalogName?: string): string {
  const key = String(role || "").toUpperCase();
  if (ROLE_LABELS[key]) return ROLE_LABELS[key];
  if (catalogName?.trim()) return catalogName.trim();
  return role || "—";
}
